import React from 'react'
import PropTypes from 'prop-types'
import { RaisedButton, FlatButton, IconButton } from 'material-ui'

class Button extends React.Component {
  render() {
    const { type, ...props } = this.props

    let button = null
    switch (type) {
      case 'flat': button = FlatButton
      break
      case 'icon': button = IconButton
      break
      default: button = RaisedButton
      break
    }

    return (
      React.createElement(button, { ...props, disableTouchRipple: true, disableFocusRipple: true })
    )
  }
}

Button.propTypes = {
  type: PropTypes.string,
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button/index.js